import { render, staticRenderFns } from "./AddExtendedFamilyModal.vue?vue&type=template&id=71270d70&scoped=true"
import script from "./AddExtendedFamilyModal.vue?vue&type=script&lang=js"
export * from "./AddExtendedFamilyModal.vue?vue&type=script&lang=js"
import style0 from "./AddExtendedFamilyModal.vue?vue&type=style&index=0&id=71270d70&prod&scoped=true&lang=css"
import style1 from "./AddExtendedFamilyModal.vue?vue&type=style&index=1&id=71270d70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71270d70",
  null
  
)

export default component.exports